import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControlOptions, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ErrorLogsService } from 'src/app/core/errorlogs.service';
import { autocompleteFilter } from 'src/app/shared/helpers/autocompleteFilter.helper';
import { ErrorLogsSearchFilters } from 'src/app/shared/models/errorlogs.model';

@Component({
  selector: 'app-errorlogs-filters',
  styles: ['.error { padding: 5px; color: red; }'],
  template: `
  <div class="card card-w-title">
    <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
      <h1>Log errori</h1>
      <div class="card grid">
        <div class="col-3">
          <div class="col-3 mt-6">Data inizio</div>
          <div class="col-9">
            <p-calendar formControlName="dateFrom" [selectOtherMonths]="true" [dateFormat]="'dd/mm/yy'"
              [showIcon]="true"></p-calendar>
          </div>
        </div>
        <div class="col-3">
          <div class="col-3 mt-6">Data fine</div>
          <div class="col-9">
            <p-calendar formControlName="dateTo" [selectOtherMonths]="true" [dateFormat]="'dd/mm/yy'"
              [showIcon]="true"></p-calendar>
          </div>
        </div>
        <div class="col-6">
          <div class="col-3 mt-6">Livello</div>
          <div class="col-9">
          <p-autoComplete formControlName="level" [suggestions]="filteredLevels"
          [delay]="20" [size]="50" [dropdown]="true" [inputStyle]="{'width': 'calc(100% - 28px)'}" [autofocus]="true"
           (completeMethod)="filterLevel($event)" ></p-autoComplete>
          </div>
        </div>
        <div class="col-1">
            <button pButton type="button" class="p-button-secondary" label="Pulisci" (click)="doClear()"  title="Pulisci"></button>
          </div>
        <div class="col-4">
            <button pButton type="button" label="Cerca" (click)="doSearch()" [disabled]=" !searchForm.valid"
              title="Cerca"></button>
              <div *ngIf="searchForm.errors" class="error" style="color: red; padding:5px">
                <i class="pi pi-exclamation-circle"></i>
                {{ searchForm.errors.dates }}
              </div>
        </div>
        <div class="col-7"></div>
      </div>
    </form>
  </div>
`
})
export class ErrorLogsFiltersComponent implements OnInit {
  @Output() public updateFiltersAndSearch = new EventEmitter<ErrorLogsSearchFilters>();

  public levels: string[] = [];
  public filteredLevels: string[] = [];
  public searchForm: FormGroup<ErrorLogFiltersForm>;
  public autocompleteFilter = autocompleteFilter;

  private searchCtrls: ErrorLogFiltersForm;

  constructor(
    fb: FormBuilder,
    private errorLogsService: ErrorLogsService
  ) {
    this.searchForm = fb.group<ErrorLogFiltersForm>({
      dateFrom: new FormControl(null),
      dateTo: new FormControl(null),
      level: new FormControl(null)
    }, { validators: this.dateLessThan('dateFrom', 'dateTo') } as AbstractControlOptions);
    this.searchCtrls = this.searchForm.controls;
  }

  doClear() {
    this.searchForm.reset();
  }

  ngOnInit(): void {
    this.levels = this.errorLogsService.getLevels();
    this.doSearch();
  }

  filterLevel(event: { query: string }): void {
    const filtered: string[] = [];
    const query = event.query;

    for (const level of this.levels) {
      if (level.toLowerCase().startsWith(query.toLowerCase())) {
        filtered.push(level);
      }
    }

    this.filteredLevels = filtered;
  }

  public doSearch(): void {
    const errorLogFilters: ErrorLogsSearchFilters = {
      level: this.searchCtrls.level.value,
      dateFrom: this.searchCtrls.dateFrom.value,
      dateTo: this.searchCtrls.dateTo.value,
    };

    this.updateFiltersAndSearch.emit(errorLogFilters);
  }

  dateLessThan(from: keyof ErrorLogFiltersForm, to: keyof ErrorLogFiltersForm) {
    return (group: FormGroup<ErrorLogFiltersForm>) => {
      const f = group.controls[from];
      const t = group.controls[to];

      if (f.value !== null && t.value !== null && f.value > t.value) {
        return {
          dates: "La data di fine deve essere maggiore o uguale alla data di inizio"
        };
      }

      return {};
    }
  }
}

interface ErrorLogFiltersForm {
  dateFrom: FormControl<Date | null>;
  dateTo: FormControl<Date | null>;
  level: FormControl<string | null>;
}
